import { render, staticRenderFns } from "./SettlementDetails.vue?vue&type=template&id=d280433e&scoped=true"
import script from "./SettlementDetails.vue?vue&type=script&lang=js"
export * from "./SettlementDetails.vue?vue&type=script&lang=js"
import style0 from "./SettlementDetails.vue?vue&type=style&index=0&id=d280433e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d280433e",
  null
  
)

export default component.exports